<template>
  <div class="w-full flex-1 flex-col ">
    <vx-card>
      <template slot="no-body">
        <!-- header -->
        <global-header :buttonBack="true" :actions="false" />

        <!-- Loading -->
        <div v-if="$apollo.queries.whistleblower.loading">
          <global-skeleton :loadingType="'CardShow'"></global-skeleton>
        </div>

        <!-- Not data -->
        <div v-else-if="!whistleblower">No data found</div>

        <!-- Load whistleblower -->
        <div
          v-else-if="!$apollo.queries.whistleblower.loading && whistleblower"
          class="w-full flex px-5"
        >
          <!-- Info -->
          <div class="w-full">
            <div class="flex flex-col md:flex-row justify-center">
              <div class="flex flex-col mb-2 flex-1">
                <div class="font-bold">Judul Laporan</div>
                <div>
                  {{whistleblower.judul}}
                </div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col md:flex-row justify-center">
              <div class="flex flex-col mb-2 flex-1">
                <div class="font-bold">Jenis Laporan</div>
                <div class="">
                  {{whistleblower.kategori_whistleblower.nama}}
                </div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col md:flex-row justify-center">
              <div class="flex flex-col mb-2 flex-1">
                <div class="font-bold">Tanggal Pelaporan</div>
                <div>{{ whistleblower.created_at | indonesian_date_time }}</div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col md:flex-row justify-center">
              <div class="flex flex-col mb-2 flex-1">
                <div class="font-bold">Status</div>
                <div class="">
                  <whistleblower-chip :status="whistleblower.status"/>
                </div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col ">
              <div class="flex flex-col mb-2">
                <div class="font-bold">Deskripsi Laporan</div> <br>
                <div v-html="whistleblower.deskripsi"></div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col">
              <div class="font-bold mb-2">Pelapor Whistleblower</div>
              <div class="flex flex-col md:flex-row">
                <global-user
                  class="flex-1"
                  :name="whistleblower.nama_pelapor"
                  :subname="whistleblower.email_pelapor"
                >
                  <div class="text-grey text-sm flex items-center">
                    <feather-icon
                      icon="ClockIcon"
                      svgClasses="w-4 h-4 mr-2 "
                    ></feather-icon>
                    {{ whistleblower.created_at | indonesian_date_time }}
                  </div>
                </global-user>
              </div>
              <vs-divider></vs-divider>
            </div>
            <div class="flex mt-5">
              <WhistleblowerFile
                :whistleblower="whistleblower"
                @submitCallback="refreshWhistleblowerQuery"
              />
            </div>
            <!-- Actions -->
            <div class="w-full my-5 shadow-md p-5 rounded-lg flex flex-col md:flex-row justify-between">
              <div class="flex flex-col md:flex-row">
                <ListActionWhistleblower 
                  :whistleblower="whistleblower"
                  @refreshData="refreshWhistleblowerQuery"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </vx-card>
    <vs-button
      @click="$router.go(-1)"
      class="mt-base"
      icon-pack="feather"
      icon="icon-arrow-left"
      type="border"
      >Kembali</vs-button
    >
  </div>
</template>

<script>
import WhistleblowerChip from "./components/WhistleblowerChip.vue";
import WhistleblowerFile from "./components/WhistleblowerFile.vue";
import ListActionWhistleblower from "./components/ListActionWhistleblower.vue";
import { GET_DETAIL } from "@/query/whistleblower";
import whistleblowerModifier from "@/modifiers/whistleblower";
import dokumenModifier from "@/modifiers/dokumen";
import {STATUS_UNREAD, STATUS_READ} from "@/const/whistleblower";
import { UPDATE } from "@/query/whistleblower";

export default {
  components: {
    WhistleblowerChip,
    WhistleblowerFile,
    ListActionWhistleblower
  },
  data() {
    return {
      uuid: this.$route.params.uuid,
      whistleblower: {}
    };
  },
  apollo: {
    whistleblower: {
      query: GET_DETAIL,
      variables() {
        return {
          id: this.uuid
        };
      },
      update(data) {
        this.setBodyTitle();
        return this.getModifiedWhistleblower(data.whistleblowerByUuid);
      },
      fetchPolicy: "cache-and-network"
    }
  },
  watch:{
    whistleblower: {
      handler(){
        this.readWhistleblower();
      },
      deep: true
    }
  },
  methods: {
    setBodyTitle() {
      const text = "Detail Whistleblower";
      this.$store.dispatch("globalApp/setHeaderTitle", text);
    },
    getModifiedWhistleblower(whistleblower) {
      whistleblower.dokumen = whistleblower.dokumen.map(dokumen => {
        return dokumenModifier(dokumen);
      });
      return whistleblowerModifier(whistleblower);
    },
    readWhistleblower(){
      const isUnreadWhistleblower = this.whistleblower.status == STATUS_UNREAD;
      if(isUnreadWhistleblower){
        const variables = {
          id: this.whistleblower.id,
          input: {
            status: STATUS_READ
          }
        };
        this.$apollo.mutate({
          mutation: UPDATE,
          variables,
          update: () => {
            this.refreshWhistleblowerQuery();
          }
        });
      }
    },
    refreshWhistleblowerQuery(interval = 50) {
      setTimeout(() => {
        this.$apollo.queries.whistleblower.skip = false;
        this.$apollo.queries.whistleblower.refetch();
        this.$store.dispatch("globalApp/refetchBadge", true);
      }, interval);
    },
  }
};
</script>

<style lang="scss">
  @import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
